import { gql } from '@apollo/client';

const KEY_TEACHER_CREATED_ACTIVITY = gql`
  fragment BaseKeyTeacherCreatedActivity on KeyTeacherCreatedActivity {
    id
    title
    text
    date
    activityGroupCount
  }
`;

export default KEY_TEACHER_CREATED_ACTIVITY;
